














import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

/**
 *  Small label to indicate something, like
 *  being an outdoor or indoor unit.
 */
@Component
export default class Label extends Vue {

    @Prop({ type: Boolean })
    private success!: boolean;

}
